import { render, staticRenderFns } from "./DashboardSuper.vue?vue&type=template&id=1217f57a"
import script from "./DashboardSuper.vue?vue&type=script&lang=js"
export * from "./DashboardSuper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports